import { gql } from "@apollo/client";

export const createInstantWin = gql`
  mutation CreateInstantWin($input: InstantWinInput!) {
    createInstantWin(input: $input) {
      id
      title
      startsAt
      endsAt
      instantWinStatus
      rollover
      fallback
      metadata
      createdAt
      updatedAt
    }
  }
`;

export const updateInstantWin = gql`
  mutation UpdateInstantWin($id: ID!, $input: InstantWinUpdateInput) {
    updateInstantWin(id: $id, input: $input) {
      id
      title
      startsAt
      endsAt
      instantWinStatus
      rollover
      fallback
      metadata
      createdAt
      updatedAt
    }
  }
`;

export const deleteInstantWin = gql`
  mutation DeleteInstantWin($id: ID!) {
    deleteInstantWin(id: $id)
  }
`;

export const archiveInstantWin = gql`
  mutation ArchiveInstantWin($id: ID!) {
    archiveInstantWin(id: $id) {
      id
    }
  }
`;

export const importPrizeSeeds = gql`
  mutation ImportPrizeSeeds($instantWinId: UUID!, $input: [PrizeSeedInput!]!) {
    importPrizeSeeds(instantWinId: $instantWinId, input: $input) {
      instantWinId
      totalPrizeSeedsImported
      prizeSeedSummary {
        rewardId
        count
        rewardDescription
      }
    }
  }
`;

export const createPrizeSeed = gql`
  mutation CreatePrizeSeed($instantWinId: UUID!, $input: PrizeSeedInput!) {
    createPrizeSeed(instantWinId: $instantWinId, input: $input) {
      id
      seedTime
      rewardId
      rewardQuantity
      rewardDescription
      metadata
      createdAt
      updatedAt
    }
  }
`;

export const updatePrizeSeed = gql`
  mutation UpdatePrizeSeed($instantWinId: UUID!, $id: ID!, $input: PrizeSeedInput) {
    updatePrizeSeed(instantWinId: $instantWinId, id: $id, input: $input) {
      id
      seedTime
      rewardId
      rewardQuantity
      rewardDescription
      metadata
      createdAt
      updatedAt
    }
  }
`;

export const deletePrizeSeed = gql`
  mutation DeletePrizeSeed($instantWinId: UUID!, $id: ID!) {
    deletePrizeSeed(instantWinId: $instantWinId, id: $id)
  }
`;

export const removePrizeSeeds = gql`
  mutation RemovePrizeSeed($instantWinId: UUID!) {
    removePrizeSeed(instantWinId: $instantWinId) {
      instantWinId
      removedCount
      removedAt
    }
  }
`;
